/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import * as React from 'react';
import {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {selectedLeavesSelector} from "../../../selectors/finder";
import {createSelector} from 'reselect';
import {getTagMap} from "../../../selectors/tags";
import {AEMApi} from "../../../api/aem.api";
import Block from "../../atoms/layout/Block";
import {withI18N} from "../../hoc/withI18N";
import {compose} from "redux";
import {isValidResponse} from "../../../utils/sagas";
import {selectRendition} from "../../../data/aem.model";
import {getHomepage, getResource} from "../../../selectors/generic";


function _TagReferenceBanner({tag, translate, applicationTags}) {
    const [reference, setReference] = useState(null);

    useEffect(() => {
        setReference(null);
        if (tag && tag.path) {
            AEMApi.fetchReference(tag.path)
                .then(response => setReference(isValidResponse(response) ? response.data : null))
                .catch(() => setReference(null));
        }
    }, [tag]);

    const image = React.useMemo(() => reference && selectRendition(reference.image, 400), [reference]);

    if (reference == null) {
        return null;
    }

    return (<Block className={"row"}>
        <Block className={"col-sm-12 col-xs-12 tag-reference-banner"}>
            <div className="thumbnail thumbnail--large">
                <div className="thumbnail__image bg-lazyload lazyload" style={{ backgroundImage: image ? "url('" + getResource(image) + "')" : null }} />
                <div className="caption">
                    {reference.title && <h5 className="p-margin-bottom-sm">
                        {reference.title}
                    </h5>}
                    {reference.text && <p className="hide-mobile">
                        {reference.text}
                    </p>}
                    <p>
                        <a href={reference.path} className={"p-link p-link--negative"}>
                            {tag ? (translate((tag.id || "").startsWith(applicationTags) ? "Discover our {0} recipes" : "More about {0}", (tag.title || ""))) : null} <span className="glyphicon glyphicon-arrow-right"/>
                        </a>
                    </p>
                </div>
            </div>
        </Block>
    </Block>);
}

const mapStateToProps = () => {
    const selector = createSelector(
        selectedLeavesSelector,
        getTagMap,
        (filters, tags) => {
            if (filters) {
                const tag = (filters.find(filter => filter && filter.length > 0) || [])[0];

                return tags[tag] ? tags[tag] : null
            }
            return null;
        }
    );

    return state => ({
        tag: selector(state),
        applicationTags: getHomepage(state).applicationTags
    });
};

export const TagReferenceBanner = compose(connect(mapStateToProps), withI18N)(_TagReferenceBanner);
